import React, { Component } from 'react';
import UpcomingBookings from 'AppClient/components/UpcomingBookings';
import PastBookingsTable from 'AppClient/components/PastBookingsTable';
import NoBookingInfo from 'AppClient/components/NoBookingInfo';
import classNames from 'classnames';
import { Spin } from 'components/antd';
import { inject, observer } from 'mobx-react';
import {
	RootStore,
	PastBookingsStore,
	UpcomingBookingsStore,
	PassengerDetailsStore,
} from 'AppClient/stores';
import { ThemeContext } from 'app-themes';

import layoutStyles from '../AppLayout/AppLayout.module.scss';
import styles from './styles.module.scss';

interface Props {
	upcomingBookingsStore?: UpcomingBookingsStore;
	pastBookingsStore?: PastBookingsStore;
	passengerDetailsStore?: PassengerDetailsStore;
}
export class MainPage extends Component<Props> {
	componentDidMount() {
		const { receivePastBookings } = this.props.pastBookingsStore!;
		const { receiveUpcomingBookings } = this.props.upcomingBookingsStore!;

		receiveUpcomingBookings();
		receivePastBookings();
	}

	render() {
		const { isLoadingPast, isData } = this.props.pastBookingsStore!;
		const { isLoadingUpcoming, hasUpcomingData } = this.props.upcomingBookingsStore!;
		const { isLoadingPassengerDetails } = this.props.passengerDetailsStore!;

		const isLoading = isLoadingUpcoming || isLoadingPast || isLoadingPassengerDetails;
		const isAnyData = isData || hasUpcomingData;
		if (isLoading && !isAnyData) {
			return (
				<Spin spinning={true}>
					<div className={styles.emptyContainerForSpinner} />
				</Spin>
			);
		}
		if (!isLoading && !isAnyData) {
			return <NoBookingInfo message="No bookings yet" noAnyDate />;
		}
		return (
			<ThemeContext.Consumer>
				{(theme: string) => (
					<Spin spinning={isLoading}>
						<div
							className={classNames(styles.booking, {
								[styles[`booking-${theme}`]]: theme !== '',
							})}
						>
							<div className={classNames(styles.bookingBox, styles.upcoming)}>
								<div className={layoutStyles.appWrapper}>
									<div className={layoutStyles.wrapper}>
										<UpcomingBookings />
									</div>
								</div>
							</div>
							<div className={layoutStyles.appWrapper}>
								<div className={classNames(styles.bookingBox, styles.past)}>
									<div className={layoutStyles.wrapper}>
										<PastBookingsTable />
									</div>
								</div>
							</div>
						</div>
					</Spin>
				)}
			</ThemeContext.Consumer>
		);
	}
}

export default inject(
	({ upcomingBookingsStore, pastBookingsStore, passengerDetailsStore }: RootStore) => ({
		upcomingBookingsStore,
		pastBookingsStore,
		passengerDetailsStore,
	})
)(observer(MainPage));
